import $ from 'jquery';
import LZString from 'lz-string';
import moment from 'moment';
import React from 'react';
import Moment from 'react-moment';
import logo from './../../assets/img/favicon-dark.png';
import CommonUtils from '../../util/CommonUtils';

class DailyReport extends React.Component {

    constructor(props) {
        super();
        this.state = { zones: [] };
    }

    componentDidMount() {
        this.params = this.getPathParams();
        console.log(JSON.stringify(this.params));
        this.preparePDFReportData();
    }

    getPathParams() {
        var pathParams = window.location.search;
        pathParams = pathParams.length > 0 ? pathParams.substring(1) : '';
        // parameter_map =
        //     {
        //         customer_id: "7777466782239",
        //         user_login: "usertest",
        //         user_token: "d0306e9d-a1e7-4c91-a97d-9e2dfce363db",
        //         site_id: "7777963129656",
        //         site_name: "East Frontyard",
        //         zones: "8457254503036,7777964567972",
        //         timezone: "America/Chicago"
        //     }
        return pathParams.length > 0 ? JSON.parse(LZString.decompressFromBase64(pathParams)) : {};
    }

    preparePDFReportData() {

        let promises = [];
        var zones = this.params.zones.split(',');
        for (var z of zones)
            promises.push(this.fetchZoneEvents(this.params, z));

        promises.push(this.fetchSiteLocationZones(this.params));

        let dailyReport = this;

        Promise.all(promises).then(function (data) {
            var result = { events: {}, counts: {}, zones: [], site_name: dailyReport.params.site_name };
            for (var i = 0; i < data.length; i++) {
                if (i === data.length - 1)
                    result['zones'] = data[i];
                else {
                    if (data[i]['location_id']) {
                        result['events'][data[i]['location_id']] = data[i]['events'];
                        result['counts'][data[i]['location_id']] = data[i]['events'];
                    }
                }
            }

            console.log(result);

            dailyReport.setState({ ...result }, function () {
                setTimeout(function () {
                    window.PHANTOM_HTML_TO_PDF_READY = true;
                })
            }, 3000);
        }).then(function (data) {
            // Do more stuff here
        });
    }

    fetchSiteLocationZones(d) {
        return new Promise(function (resolve, reject) {
            $.ajax(
                {
                    url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/location',
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    data: JSON.stringify(d)
                }
            ).then(
                (res) => {
                    var zones = [];
                    if (res.status && res.status.code === 200) {
                        zones = res.data;
                    }
                    resolve(zones);
                },
                (res) => {
                    resolve([]);
                });
        });
    }

    fetchZoneEvents(d, l) {
        let dailyReport = this;
        return new Promise(function (resolve, reject) {
            $.ajax(
                {
                    url: 'https://gygnti76i5.execute-api.us-east-1.amazonaws.com/api-env-prod/event/' + l,
                    type: 'POST',
                    contentType: "application/json; charset=utf-8",
                    dataType: "json",
                    data: JSON.stringify(d)
                }
            ).then(
                (res) => {
                    var result = {};
                    if (res.status && res.status.code === 200) {
                        var timezone = dailyReport.params.timezone;
                        if (!timezone)
                            timezone = moment.tz.guess(); // User's timezone if not found

                        // Filtering events which are 1 day older or less.
                        var counts = { alert: 0, warning: 0 };
                        var m1 = moment.tz(new Date().getTime(), timezone);
                        var filteredEvents = (res.data).filter(evt => {
                            var m2 = moment.tz(evt.timestamp, timezone).add(-5, 'hours');
                            var diff = m1.diff(m2, 'days');
                            //console.log('M1 : ' + m1.format('YYYY-MM-DD HH:mm') + ', M2 : ' + m2.format('YYYY-MM-DD HH:mm') + ', DIFF : ' + diff);
                            if (diff <= 1)
                                counts[evt.event_level] += 1;
                            return diff <= 1;
                        });

                        result.events = filteredEvents;
                        result.counts = counts;
                        result.location_id = l;
                    }
                    resolve(result);
                },
                (res) => {
                    resolve([]);
                });
        });
    }

    render() {
        const faIcons = { 'temperature': 'fa-thermometer-half', 'humidity': 'fa-tint', 'motion': 'fa-street-view', 'co': 'fa-info-circle', 'voc': 'fa-info-circle' };
        return (
            <React.Fragment>

                <div className="container">
                    <div className="row">
                        <div className="col-md-12 my-5">
                            <span className="navbar-brand text-primary">
                                <img src={logo} alt="logo" style={{ width: "25px", marginRight: '10px' }} />
                                {"SiteSupt OnDemand"}
                            </span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-12">
                            <h4>Daily Report</h4>
                        </div>
                        <div className="col-md-12">
                            <h5 className="text-app">{this.state.site_name}</h5>
                        </div>
                        {
                            this.state.zones.map((zone, i) => (
                                <div key={i} className="col-md-12" zone={zone.location_id}>
                                    <div className="card border border-light m-2 bg-shadow">
                                        <div className="card-body p-0">
                                            <img className="card-img-top img-fluid d-block" src={zone.image} alt={zone.location_name} onClick={this.showZoneHistory} />
                                        </div>
                                        <div className="card-header bg-light border border-light text-app border-top-light">
                                            <b className="font-weight-700">{zone.location_name}</b>
                                            <div className="text-dark">
                                                <span className="font-size-12 font-weight-300">
                                                    <Moment format="MMM DD, YYYY HH:mm" tz={"America/Chicago"}>
                                                        {zone.location_lastupdate}
                                                    </Moment>
                                                </span>
                                                <span className="pull-right font-size-12">
                                                    <span className="text-primary">
                                                        {CommonUtils.formatSensorData('temperature', (Math.round(zone.location_temperature * 100, 2) / 100))}
                                                    </span>
                                                    <span className="ml-3 text-primary">
                                                        {CommonUtils.formatSensorData('humidity', (Math.round(zone.location_humidity * 100, 2) / 100))}
                                                    </span>
                                                </span>

                                            </div>
                                        </div>

                                        {this.state.events[zone.location_id] && <div className="card-text p-3">
                                            {
                                                this.state.events[zone.location_id].map((zone_event, z) => (
                                                    <div className="event-info-alert mb-4" key={z}>
                                                        <span className="font-weight-bold text-capitalize">
                                                            <i className={"fa " + faIcons[zone_event.sensor_id] + ' event-' + zone_event.event_level}></i> {zone_event.sensor_id}
                                                        </span>
                                                        <span className="pull-right font-size-12">
                                                            <Moment format="MMM DD, YYYY HH:mm" tz={this.props.timezone}>
                                                                {zone_event.timestamp}
                                                            </Moment>
                                                        </span>
                                                        <br />
                                                        <span className="text-capitalize font-size-12 py-2">{zone_event.event_message}</span>
                                                    </div>
                                                ))
                                            }
                                        </div>}

                                    </div>
                                </div>

                            ))
                        }
                    </div>
                </div>
            </React.Fragment>
        )
    }

}
export default DailyReport;